export default "__VITE_PUBLIC_ASSET__873aa3ae__"